import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();

  return (
    <ThermalReceipt
      ref={ref}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      note={t("hr.advanceForm")}
      rows={[
        { label: `${t("hr.employee")}:`, value: data?.employee_display || "-" },
        { label: `${t("hr.month")}:`, value: data?.month_display || "-" },
        { label: `${t("hr.year")}:`, value: data?.year || "-" },
        { label: `${t("hr.paidDate")}:`, value: data?.date || "-" },
      ]}
      totals={[{ label: t("hr.amount"), value: money(data?.amount), bold: true }]}
      footerLines={[t("print.cosmos")]}
    />
  );
});

export default Print;
